import type { FC } from "react";
import { Article, Separator } from "@/ui";
import {
  CAT_LIFESTYLE_CARD_ARTICLE_CLASS,
  CAT_LIFESTYLE_CARD_DEFAULTS,
  type TCatLifestyleCardProps,
} from "./CatLifestyleCard.config";
import {
  CatLifestyleCardCaloriesSection,
} from "./CatLifestyleCardCaloriesSection";
import { CatLifestyleCardHealthSection } from "./CatLifestyleCardHealthSection";
import { useCatLifestyleCard } from "./useCatLifestyleCard";

export const CatLifestyleCard: FC<TCatLifestyleCardProps> = ({
  cat,
  calorieDescription,
  alert,
  onEditHealth,
  onEditCalories,
  "data-component": component = CAT_LIFESTYLE_CARD_DEFAULTS["data-component"],
}) => {
  const {
    healthStats,
    healthTitle,
    portionSizeTitle,
    dailyCalories,
    editCopy,
    editHealthAriaLabel,
    editCaloriesAriaLabel,
  } = useCatLifestyleCard(cat);

  return (
    <Article
      data-component={component}
      className={CAT_LIFESTYLE_CARD_ARTICLE_CLASS}
    >
      <CatLifestyleCardHealthSection
        title={healthTitle}
        editAriaLabel={editHealthAriaLabel}
        editCopy={editCopy}
        onEdit={onEditHealth}
        healthStats={healthStats}
      />

      <Separator className="my-4" />

      <CatLifestyleCardCaloriesSection
        title={portionSizeTitle}
        description={calorieDescription}
        editAriaLabel={editCaloriesAriaLabel}
        editCopy={editCopy}
        onEdit={onEditCalories}
        calories={dailyCalories}
        alert={alert}
      />
    </Article>
  );
};

CatLifestyleCard.displayName = "CatLifestyleCard";
